import { StrictMode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App.tsx";
import { store } from "./app/store";
import "./styles.scss";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <ErrorBoundary fallback={<div>Failed to load</div>}>
            <Provider store={store}>
                <App />
            </Provider>
        </ErrorBoundary>
    </StrictMode>
);
